import { CircularProgress } from '@mui/material';
import React from 'react';

const Loader = () => {
  return <CircularProgress color='inherit' size={24} />;
};

export default Loader;
